// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-1{margin:1rem 0}.text__subtitle{font-size:.9rem;margin-bottom:1rem}.text__interesado__help{font-size:10.4px!important;margin-top:.3rem;margin-bottom:0!important}.text__interesado__error{color:#b64351!important;margin-top:.5rem}", ""]);
// Exports
module.exports = exports;
